import * as THREE from "three"
import { CSS3DRenderer } from "three/examples/jsm/renderers/CSS3DRenderer.js"

import Experience from "./Experience.js";

export default class Renderer {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.camera = this.experience.camera


        // Set Instance
        this.setInstance()

    }

    setInstance() {
        const useAntialias = true

        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: useAntialias,
            // powerPreference: "high-performance"
        })
        this.instance.outputColorSpace = THREE.SRGBColorSpace
        this.instance.toneMapping = THREE.CineonToneMapping
        this.instance.setClearColor("#000000")
        this.instance.toneMappingExposure = 1.75
        this.instance.shadowMap.enabled = !this.sizes.isMobile
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)

        this.cssInstance = new CSS3DRenderer()
        this.cssInstance.setSize(this.sizes.width, this.sizes.height)
        this.cssInstance.domElement.style.position = 'absolute'
        this.cssInstance.domElement.style.top = '0'
        this.cssInstance.domElement.style.left = '0'
        this.cssInstance.domElement.style.width = '100%'
        this.cssInstance.domElement.style.height = '100%'
        this.cssInstance.domElement.style.pointerEvents = 'none'
        this.cssInstance.domElement.style.overflow = 'hidden'
        this.cssInstance.domElement.style.transformStyle = 'preserve-3d'
        this.cssInstance.domElement.style.backfaceVisibility = 'hidden'
        document.body.appendChild(this.cssInstance.domElement)

    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(this.sizes.pixelRatio)
        this.cssInstance.setSize(this.sizes.width, this.sizes.height)
    }

    update() {
        this.instance.render(this.scene, this.camera.instance)
        this.cssInstance.render(this.scene, this.camera.instance)
    }
}
